const echarts = require("echarts");

export default function (data) {
  var fontColor = "#fff";
  return {
    // color: [
    //   "#bf19ff",
    //   "#854cff",
    //   "#5f45ff",
    //   "#02cdff",
    //   "#0090ff",
    //   "#f9e264",
    //   "#f47a75",
    //   "#009db2",
    //   "#0780cf",
    //   "#765005",
    // ],
    backgroundColor: "",
    textStyle: {
      fontSize: 18,
    },
    title: {
      show: false,
      text: "",
      left: "left",
      textStyle: {
        color: fontColor,
        align: "center",
      },
    },
    grid: {
      top: "50",
      left: "10",
      right: "10",
      bottom: "10",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
        label: {
          show: true,
          backgroundColor: "#333",
        },
      },
    },
    legend: {
      show: true,
      x: "center",
      top: "10",
      textStyle: {
        color: fontColor,
        fontSize: "10px",
      },
      data: ["个人清洁", "压痔处理", "饮食照料", "起居照料", "其它"],
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        axisLabel: {
          color: fontColor,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#397cbc",
          },
        },
        data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "",
        axisLine: {
          lineStyle: {
            color: fontColor,
          },
        },
      },
    ],
    series: [
      {
        name: "个人清洁",
        type: "line",
        symbolSize: 4,
        label: {
          normal: {
            show: false,
            position: "top",
          },
        },
        itemStyle: {
          normal: {
            areaStyle: {
              //color: '#94C9EC'
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(7,44,90,0.3)",
                },
                {
                  offset: 1,
                  color: "rgba(0,146,246,0.9)",
                },
              ]),
            },
          },
        },
        data: data.grqj,
      },
      {
        name: "压痔处理",
        type: "line",
        stack: "总量",
        symbol: "circle",
        symbolSize: 8,
        label: {
          normal: {
            show: false,
            position: "top",
          },
        },
        itemStyle: {
          normal: {
            areaStyle: {
              //color: '#94C9EC'
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(7,44,90,0.3)",
                },
                {
                  offset: 1,
                  color: "rgba(0,212,199,0.9)",
                },
              ]),
            },
          },
        },
        data: data.yzcl,
      },
      {
        name: "饮食照料",
        type: "line",
        stack: "总量",
        symbol: "circle",
        symbolSize: 8,
        label: {
          normal: {
            show: false,
            position: "top",
          },
        },
        itemStyle: {
          normal: {
            areaStyle: {
              //color: '#94C9EC'
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(7,44,90,0.3)",
                },
                {
                  offset: 1,
                  color: "rgba(114,144,89,0.9)",
                },
              ]),
            },
          },
        },
        data: data.yszl,
      },
      {
        name: "起居照料",
        type: "line",
        stack: "总量",
        symbol: "circle",
        symbolSize: 8,
        label: {
          normal: {
            show: false,
            position: "top",
          },
        },
        itemStyle: {
          normal: {
            areaStyle: {
              //color: '#94C9EC'
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(7,46,101,0.3)",
                },
                {
                  offset: 1,
                  color: "rgba(0,166,246,0.9)",
                },
              ]),
            },
          },
        },
        data: data.qjzh,
      },
      {
        name: "其它",
        type: "line",
        stack: "总量",
        symbol: "circle",
        symbolSize: 8,
        label: {
          normal: {
            show: false,
            position: "top",
          },
        },
        itemStyle: {
          normal: {
            areaStyle: {
              //color: '#94C9EC'
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(7,44,90,0.3)",
                },
                {
                  offset: 1,
                  color: "rgba(0,212,199,0.9)",
                },
              ]),
            },
          },
        },
        data: data.other,
      },
    ],
  };
}
